import React from 'react';
import { ListItem, ListItemContent, Box } from "@mui/joy";
import { Button } from '../../../../mtska-frontend-app-component/components/Button';

import { useTranslation } from 'react-i18next'
import {Tag, LegalEntityAvatar} from '../../../../mtska-frontend-app-component/components/Snippet';
import { useFormatter } from '../../../../mtska-frontend-app-component/utils';

const RelationshipCar = ({ k, v, editing, detailInspector = true, handleItemDetail, handleItemRemove, loadingDissociation }) => {
    const { t, i18n } = useTranslation();
    const { formatCurrency } = useFormatter();

    const tagcolors = {
        installed: "success",
        running: "success",
        available: "warning",
        in_order: "secondary",
        in_offer: "secondary",
        in_configuration: "secondary",
        closed: "danger",
        preleasing: "warning",
        substitute: "warning",
        archived: "danger"
    }

    const getType = (v) => {
        return v?.type ? v?.type.toLowerCase() : '';
    }

    const getStatus = (v) => {
        return v?.status ? v?.status.toLowerCase() : 'running';
    }

    return (
        <>
            <ListItem key={k} variant="outlined" className={"relationship-element"}>
                {/* { <textarea>{ JSON.stringify(v)}</textarea> } */}
                <ListItemContent className={"relationship-element-content vehicle-type-" + getType(v) + " vehicle-status-" + getStatus(v)}>
                    <Box className={"makeandorder"}>
                        <span className={"make"} title={(v?.setup?.make || '') + " " + (v?.setup?.model || '-') + " " + (v?.setup?.name || '-')}>{(v?.setup?.make || '-') + " " + (v?.setup?.model || '-') + " " + (v?.setup?.name || '')}</span>
                        {v.pool?.isPool === 'true' ? t('pool_assignment') : t('direct_assignment')}

                    </Box>
                    <Box className={"plate"}>
                        {v?.plate}
                    </Box>
                    {
                        v?.contract ? (
                            <LegalEntityAvatar name={v?.contract?.renter?.name} url={v?.contract?.renter?.logo?.url} withname={true} detail={formatCurrency(v?.contract?.totalLeaseFee) + ' ' + (v?.contract?.orderIdentifier ?? t('Missing order identifier'))} />
                        ) : (
                            <LegalEntityAvatar size="small" withname={true} error={t('No contract')} />
                        )
                    }
                    <Box className={"status"}>
                        <Tag color={(tagcolors[getStatus(v)])} size="small" label={t(getStatus(v))} />
                    </Box>
                  
                </ListItemContent>

                {editing && handleItemDetail && detailInspector && (<Button onClick={() => handleItemDetail(v)} icon="faPen" variant="plain" />)}
                {editing && handleItemRemove && (<Button onClick={() => handleItemRemove(v)} icon="faClose" variant="plain" loading={loadingDissociation} />)}
            </ListItem>
        </>
    )
}


export default RelationshipCar


